import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {FieldTree} from "@angular/forms/signals";

/** Encapsulates the logic to decide whether to display a signal-form field's error(s), if any,
 * and format them as a single string;
 */
@Component({
    selector: 'app-field-errors',
    templateUrl: './field-errors.component.html',
    styleUrl: './field-errors.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FieldErrorsComponent {
    formField = input.required<FieldTree<string,any>>();

    errors(): string {
        return this.formField()().errors().map(e => e.message).join('; ');
    }
}
